import { apiCreate, apiGetList } from './ApiBaseActions';
export const API_GET_LIST_SEARCH_SOLUTION = 'API_GET_LIST_SEARCH_SOLUTION';
export const API_GET_LIST_SEARCH_SOLUTION_SUCCESS = 'API_GET_LIST_SEARCH_SOLUTION_SUCCESS';
export const API_GET_LIST_SEARCH_SOLUTION_MORE = 'API_GET_LIST_SEARCH_SOLUTION_MORE';
export const API_GET_LIST_SEARCH_SOLUTION_MORE_SUCCESS = 'API_GET_LIST_SEARCH_SOLUTION_MORE_SUCCESS';
export const SEARCH_SOLUTION_PARAM_SET = 'SEARCH_SOLUTION_PARAM_SET';
export const SEARCH_SOLUTION_PARAM_REPLACE = 'SEARCH_SOLUTION_PARAM_REPLACE';
export const SEARCH_SOLUTION_VIEW_SET = 'SEARCH_SOLUTION_VIEW_SET';
export const SEARCH_SOLUTION_VIEW_REPLACE = 'SEARCH_SOLUTION_VIEW_REPLACE';
export const SEARCH_SOLUTION_PRE_KEYWORD_SET = 'SEARCH_SOLUTION_PRE_KEYWORD_SET';
export const API_SEARCH_SOLUTION_PICKUP = 'API_SEARCH_SOLUTION_PICKUP';
export const apiGetListSearch = (params, lastQuery) => apiGetList(API_GET_LIST_SEARCH_SOLUTION, '/client/solution', params, {
    cancelPrevious: true,
    lastQuery,
});
export const apiGetListMoreSearch = (params, page) => apiGetList(API_GET_LIST_SEARCH_SOLUTION_MORE, '/client/solution', Object.assign(Object.assign({}, params), { page }), { cancelPrevious: true, page });
export const searchParamSet = (payload) => ({
    payload,
    type: SEARCH_SOLUTION_PARAM_SET,
});
export const searchParamReplace = (payload) => ({
    payload,
    type: SEARCH_SOLUTION_PARAM_REPLACE,
});
export const searchKeywordSet = (keyword) => ({
    payload: {
        keyword,
    },
    type: SEARCH_SOLUTION_PARAM_SET,
});
export const searchViewSet = (payload) => ({
    payload,
    type: SEARCH_SOLUTION_VIEW_SET,
});
export const searchViewReplace = (payload) => ({
    payload,
    type: SEARCH_SOLUTION_VIEW_REPLACE,
});
export const searchPreKeywordSet = (payload) => ({
    payload,
    type: SEARCH_SOLUTION_PRE_KEYWORD_SET,
});
export const solutionPickup = (payload, meta) => apiCreate(API_SEARCH_SOLUTION_PICKUP, '/client/solution/pickup', payload, meta);
